import { useMutation, useQueryClient } from 'react-query';
import { AxiosError } from 'axios';
import api from 'services';
import { ApiError } from 'services/api.errors';
import { EmployerPayload, EmployerResponse, ID } from 'services/requests';
import { QueryKeys } from 'constants/queryKeys';
import { MutationKeys } from 'constants/mutationKeys';
import { Messages } from 'constants/messages';
import { showInfoToast } from 'components/Toast';

type EditEmployerType = {
  id: ID;
  payload: EmployerPayload;
};

export const useEditEmployer = () => {
  const queryClient = useQueryClient();

  const mutate = async ({ id, payload }: EditEmployerType) => {
    const { data } = await api.editEmployer(id, payload);

    return data;
  };

  const mutationKey = MutationKeys.editEmployer;

  return useMutation<EmployerResponse, AxiosError<ApiError>, EditEmployerType>(
    mutationKey,
    mutate,
    {
      onSuccess: () => {
        queryClient.invalidateQueries(QueryKeys.employers);
        showInfoToast(Messages.saveChanges);
      },
    },
  );
};
